<template>
  <div class="self-signup-v2">
    <calendar
      v-if="showCalendar"
      :months="displayedMonths"
      :active-date-filter="filters.single_date"
      :calendar-navigation-boundaries="calendarNavigationBoundaries"
      :day-names="dayNames"
      :is-iframe="isIframe"
      :is-full-width="isFullWidth"
      @loadCalendarSet="loadCalendar()"
      @loadCourseResults="filterBySingleDay($event)"
      @addToFilters="addToFilters($event.key, $event.value)"
      @removeFilter="removeFilter($event)"
    />
    <filters
      :filter-options="filterOptions"
      :active-filters="filters"
      :is-iframe="isIframe"
      :is-full-width="isFullWidth"
      :selected-calendar-month="selectedCalendarMonth"
      @add-to-filters="addToFilters($event.key, $event.value)"
      @clear-filters="clearFilters()"
      @reload-calendar="loadCalendar()"
    />
    <div
      v-if="!showCalendar && courseResults.length >= 20"
      class="tdesk-primary-notice info"
      style="width: 100%;"
    >
      <i class="fal" />
      Showing 20 upcoming courses.
      <a href="#" style="margin-left: 3px;" @click="clearFilters(true)">
        View full list
      </a>
    </div>
    <div
      v-if="loading && !isIframe"
      style="display:flex;justify-content:center;order:3;width:100%;margin-bottom:100px;"
    >
      <div class="tdesk-no-search-results-placeholder">
        <i class="fas fa-spinner fa-spin" />
        <h3>Getting results...</h3>
      </div>
    </div>
    <course-list
      v-else-if="courseResults.length > 0"
      :courses="courseResults"
      :is-iframe="isIframe"
      :skip-payment="skipPayment"
      :timezone="timezone"
      :is-full-width="isFullWidth"
    />
    <div
      v-if="hideDatePickNotice"
      class="tdesk-no-content-placeholder"
    >
      <i class="far fa-calendar-alt tdesk-neutral-medium" />
      <h2 style="margin-bottom: 0" class="tdesk-neutral-medium">
        Pick a date from the calendar to see courses.
      </h2>
    </div>
  </div>
</template>
<script>
  import Filters from './filters';
  import Calendar from './calendar';
  import CourseList from './course_list';

  export default {
    components: {Calendar, CourseList, Filters},
    props: {
      filterOptions: {
        type: Object,
        required: true,
      },
      pageLoadedWithSearch: {
        type: Boolean,
        required: true,
      },
      skipPayment: {
        type: Boolean,
        required: true,
      },
      months: {
        type: Array,
        required: true,
      },
      isIframe: {
        type: Boolean,
        required: false,
      },
      isFullWidth: {
        type: Boolean,
        required: false,
      },
      dayNames: {
        type: Array,
        required: true,
      },
      calendarDateSets: {
        type: Object,
        required: true,
      },
      baseFilters: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        displayedMonths: this.months,
        calendarSets: this.calendarDateSets,
        windowWidth: 0,
        courseResults: [],
        filters: this.baseFilters,
        loading: false,
      };
    },
    computed: {
      filterMap() {
        return {
          st: this.filters.state,
          sb: this.filters.suburb,
          td: this.filters.to_date_filter,
          fd: this.filters.from_date_filter,
          c: this.filters.show_calendar,
          sd: this.filters.single_date,
          uid: this.filters.unit_ids,
          timezone: this.timezone,
          dm: this.filters.delivery_mode,
          vn: this.filters.venue_id,
        };
      },
      hideDatePickNotice(){
        if (this.loading === true) {return false;}
        if (!this.isIframe && this.showCalendar && this.courseResults.length < 1) {return true;}

        return false;
      },
      timezone() {
        return App.Lib.TimezoneService.guessTimezone();
      },
      showCalendar() {
        if (this.filters.show_calendar) {
          return true;
        }
        return this.filters.show_calendar;
      },
      selectedCalendarMonth() {
        if (!this.filters.single_date || !this.filters.show_calendar) {
          return;
        }
        let date = new Date(this.filters.single_date);
        return date.toLocaleString('default', {month: 'long'});
      },
      singleCalendar() {
        return this.windowWidth <= 1180;
      },
      nextCalendarDate() {
        let set = this.calendarSets;
        return this.singleCalendar ? set.next_one_month : set.next_three_months;
      },
      prevCalendarDate() {
        let set = this.calendarSets;
        return this.singleCalendar ? set.previous_one_month : set.previous_three_months;
      },
      calendarNavigationBoundaries() {
        return {
          previous: this.prevCalendarDate,
          next: this.nextCalendarDate,
        };
      },
    },
    mounted() {
      var self = this;

      if (this.isIframe) {
        this.removeFromDOM('.self-signup-v2-header');
        this.removeFromDOM('.self-signup-v2-footer');
        this.removeFromDOM('.self-signup-v2-page-header');
      }

      if (!this.showCalendar) {
        self.loadCalendar();
      }

      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth);
        if (this.filters.single_date) {
          self.filterBySingleDay({single_date: this.filters.single_date});
        }
        this.getWindowWidth();
      });
    },
    methods: {
      removeFromDOM(selector) {
        let element = document.querySelector(selector);
        element.parentNode.removeChild(element);
      },
      clearFilters(forceCalendar = false) {
        let url = window.location.pathname + window.location.hash;
        if (this.filters.show_calendar || forceCalendar) {
          return window.top.location = url;
        }
        return window.top.location = url.concat('?c=false');
      },
      loadCalendar() {
        var self = this;
        this.loading = true;
        axios({
          method: 'get',
          headers: {'Accept': 'application/json'},
          url: Routes.populate_calendar_self_signup_calendar_index_path(self.filterMap),
        }).then(function (response) {
          if (response.status === 200) {
            self.displayedMonths = response.data.months;
            self.calendarSets = response.data.navigation_boundaries;

            if (self.filters.single_date) {
              return self.filterBySingleDay(self.filters);
            }
            self.courseResults = response.data.results;
            self.loading = false;
          }
        });
      },
      removeFilter(key) {
        this.filters[key] = null;
        let url = new URL(window.location.href);
        url.searchParams.delete(this.minifiedQueryKey(key));
        history.pushState(null, '', url);
        this.loadCalendar();
      },
      minifiedQueryKey(humanizedKey) {
        switch (humanizedKey) {
          case 'single_date':
            return 'sd';
          case 'from_date_filter':
            return 'fd';
          case 'to_date_filter':
            return 'td';
          case 'state':
            return 'st';
          case 'suburb':
            return 'sb';
          case 'unit_ids':
            return 'uid';
          case 'show_calendar':
            return 'c';
          case 'delivery_mode':
            return 'dm';
          case 'venue_id':
            return 'vn';
        }
      },
      addToFilters(key, value) {
        if (key === 'unit_ids') {
          if (!this.filterMap.uid) {
            this.filters.unit_ids = [];
          }
          this.filters.unit_ids = value;
        } else {
          this.filters[key] = value;
        }

        let url = new URL(window.location.href);
        url.searchParams.set(this.minifiedQueryKey(key), value);
        history.pushState(null, '', url);
      },
      filterBySingleDay(filters) {
        var self = this;
        this.loading = true;
        axios({
          method: 'get',
          headers: {'Accept': 'application/json'},
          url: Routes.populate_calendar_self_signup_calendar_index_path({
            fd: filters.single_date,
            td: filters.single_date,
            c: this.filters.show_calendar,
            uid: this.filters.unit_ids,
            st: this.filters.state,
            sb: this.filters.suburb,
            timezone: this.timezone,
            dm: this.filters.delivery_mode,
            vn: this.filters.venue_id,
          }),
        }).then(function (response) {
          if (response.status === 200) {
            self.courseResults = response.data.results;
            self.loading = false;
          }
        });
      },
      getWindowWidth: function () {
        this.windowWidth = document.documentElement.clientWidth;
      },
    },
  };
</script>
